module.exports = __webpack_public_path__ + "img/3.19bb7070.jpg";